<div [formGroup]="this.formGroup" class="mt-{{FIELD_SPACING}}">
  <div class="row">
    <div class="col col-md-{{TITLE_COLUMNS}}">
      <div class="form-label">{{this.label}}<br *ngIf="this.label2"/>{{this.label2}}
        <span *ngIf="this.isOptional" class="optional-tag">&nbsp;(optional)</span>
      </div>
    </div>
    <div *ngIf="this.subText != null" class="col-md-12 mb-20">
      <div [innerHTML]="this.subText"></div>
    </div>
  </div>
  <div class="row">
    <div class="col col-md-{{columns}}" [ngClass]="[inputWidth]">
      <select 
        id="{{this.propertyId}}"
        name="{{this.propertyName}}"  
        formControlName="{{this.propertyName}}" 
        class="form-control"
        [ngClass]="[this.isInvalid() ? 'is-invalid' : '',  regular ? '' : 'input-box']"
        (change)="this.userAction($event)">
          <option *ngFor="let i of this.dropdownData" [value]="i.code">{{i.display}}</option>
      </select>
    </div>
  </div>
  <app-validator-message [formGroup]="this.formGroup" propertyName="{{this.propertyName}}"></app-validator-message>
</div>